

import React, { useState } from 'react'
import PropTypes from 'prop-types'
import { Form } from 'react-bootstrap'
import withStyles from 'isomorphic-style-loader/withStyles'
import * as styles from './_AdministratorAdd.scss'
import FieldGroup from '../../../../common/forms/FieldGroup'
import EmailAddressInput from '../../../../common/forms/EmailAddressInput'
import SubmitButton from '../../../../common/forms/SubmitButton'
import history from '../../../../core/history'

const validateValue = (value) => {
  if (!value || value.trim().length === 0) {
    return {
      isInvalid: true,
      message: 'Please enter a value'
    }
  }

  return {
    isInvalid: false,
    message: null
  }
}

const AdministratorAdd = ({
  administrator = {},
  isInvalid = {},
  setEmailAddress,
  setFirstName,
  setLastName,
  submit
}) => {
  const [showSuccess, setShowSuccess] = useState(false)

  const goToAdmins = () => {
    history.push('/administration/administrators')
  }

  const handleSubmit = () => {
    submit(administrator)

    setShowSuccess(true)
  }

  return (
    <div className={styles.wrapper}>
      <h1 className={styles.heading}>
        Add Administrator
      </h1>

      <form>
        <Form.Group controlId="administrator-add-form">

          <EmailAddressInput
            id="administrator-add-email-address"
            label="Email Address"
            required
            validation={isInvalid.emailAddress || { isInvalid: false }}
            value={administrator.emailAddress || ''}
            setEmail={(validation, value) => {
              setEmailAddress(validation, value)
            }}
          />

          <FieldGroup
            id="administrator-first-name"
            label="First Name"
            required
            value={administrator.firstName || ''}
            message={isInvalid.firstName?.message}
            isInvalid={isInvalid.firstName?.isInvalid}
            handleChange={(value) => {
              setFirstName(validateValue(value), value)
            }}
          />

          <FieldGroup
            id="administrator-add-last-name"
            label="Last Name"
            required
            value={administrator.lastName || ''}
            message={isInvalid.lastName?.message}
            isInvalid={isInvalid.lastName?.isInvalid}
            handleChange={(value) => {
              setLastName(validateValue(value), value)
            }}
          />

          <div className={styles['button-row']}>

            <SubmitButton
              onClick={handleSubmit}
              isValid={isInvalid.formIsValid}
              preventDefault
              isSubmitting={false}
              buttonText="Add Administrator"
            />

            <span
              onClick={goToAdmins}
              className={styles['cancel-link']}
            >
              Cancel
            </span>

          </div>

          {showSuccess && (
            <div className={styles['success-message']}>
              <span className={styles['success-icon']}>
                ✓
              </span>
              Administrator added and can now reset their password
            </div>
          )}

        </Form.Group>
      </form>
    </div>
  )
}

AdministratorAdd.propTypes = {
  administrator: PropTypes.object,
  isInvalid: PropTypes.object,
  setEmailAddress: PropTypes.func.isRequired,
  setFirstName: PropTypes.func.isRequired,
  setLastName: PropTypes.func.isRequired,
  submit: PropTypes.func.isRequired
}

export default withStyles(styles)(AdministratorAdd)